import PropTypes from "prop-types";
import { CalendarCheckRegularV6 } from "@shared/v2/Icomoon";
import CardAppointmentMenu from "./CardAppointmentMenu";
import AppointmentDueDate from "./AppointmentDueDate";
import CardDetail from "./CardDetail";

const CardAppointment = ({ task, showTaskDetails, onEditTask, onDeleteTask, completeTask }) => (
  <div className="tw-shadow-card tw-rounded-[6px] tw-p-[16px] tw-flex tw-flex-col">
    <div className="tw-flex tw-justify-between tw-gap-[4px]">
      <div className="tw-flex">
        <div className="tw-flex tw-items-center">
          <CalendarCheckRegularV6 size="l" />
        </div>
        <div className="tw-flex tw-items-center tw-pl-[8px] tw-font-semibold tw-text-12 tw-text-gray-75">
          {task.name}
        </div>
      </div>

      <CardAppointmentMenu
        editFn={() => onEditTask(task)}
        completeFn={() => completeTask(task)}
        viewDetailsFn={() => showTaskDetails(task)}
        deleteAppointmentFn={() => onDeleteTask(task)}
        isCompleted={task.state === "completed"}
        btnSize="small"
      />
    </div>
    <AppointmentDueDate
      customClassName="tw-pl-[25px]"
      dueness={task.dueness}
      dueDate={task.calculated_due_on || task.due_on}
      scheduledTime={task.scheduled_time}
      preferScheduledTime
    />

    <div className=" tw-pt-[16px] tw-flex tw-flex-col tw-gap-[8px]">
      {task.appointment_type && <CardDetail title="Type" value={task.appointment_type} />}
      <CardDetail title="Status" value={task.completed_at ? "Completed" : "Scheduled"} />
      {task.location && <CardDetail title="Location" value={task.location} />}
      {task.outcome && <CardDetail title="Outcome" value={task.outcome} />}
      {task.note && <CardDetail title="Notes" value={task.note} />}
    </div>
  </div>
);

CardAppointment.propTypes = {
  task: PropTypes.shape().isRequired,
  showTaskDetails: PropTypes.func.isRequired,
  onDeleteTask: PropTypes.func.isRequired,
  onEditTask: PropTypes.func.isRequired,
  completeTask: PropTypes.func.isRequired,
};

export default CardAppointment;
